<template>
  <div v-cloak class="pb-4">
    <div>
      <b-container>
        <b-row>
          <b-col cols="12" md="6">
            <div class="date-description">{{'tableStartDate' | localize}} </div>
            <vue-monthly-picker
              :monthLabels="dates"
              :placeHolder="no_data_text"
              alignment="center"
              :min="min_date"
              :max="max_date"
              v-model="date_1">
            </vue-monthly-picker>
          </b-col>
          <b-col>
            <div class="date-description">{{'tableEndDate' | localize}} </div>
            <vue-monthly-picker
              :monthLabels="dates"
              :placeHolder="no_data_text"
              :min="min_date"
              :max="max_date"
              alignment="center"
              v-model="date_2">
            </vue-monthly-picker>
          </b-col>
        </b-row>
      </b-container>
      <div class="date-component">

      </div>

      <b-button 
        type="submit"
        class="px-4 my-4 mx-auto style-button button-pay-all"
        size="lg" 
        variant="outline-danger"
        @click="newTable"
      >
        {{'tableButton' | localize}}  
        <div class="style-button-icon"> 
          <b-icon icon="table" ></b-icon> 
        </div> 
      </b-button>


  </div>

    <table class="table table-striped table-bordered table-responsive text-center">
      <thead>
        <tr>
          <th v-for="(column, i) in columns" v-bind:key="i">{{ column }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(balanceData, i) in userAccountBalanceInfoData" v-bind:key="i">
          <td v-for="(field, j) in responseFields" v-bind:key="j">
            {{ field === 'period' ? writtenDate(balanceData[field]) : balanceData[field] }}
          </td>
        </tr>
      </tbody>
    </table>
    <b-button
        size="lg"
        variant="outline-danger"
        class="px-4 mb-3 mx-auto style-button button-pay-all"
        @click="printPDFArchive()">
      {{'tablePrintButton' | localize}}
      <div class="style-button-icon">
        <b-icon icon="printer" ></b-icon>
      </div>
    </b-button>
    <b-button
        size="lg"
        variant="outline-danger"
        class="px-4 mb-3 mx-auto style-button button-pay-all"
        @click="printPDF()">
      {{'tablePrintTittle' | localize}}
      <div class="style-button-icon">
        <b-icon icon="printer" ></b-icon>
      </div>
    </b-button>
  <b-button
    size="lg"
    variant="outline-danger"
    class="px-4 mb-3 mx-auto style-button button-pay-all"
    @click="printInquiry()">
    {{'getDebtCertificate' | localize}}
      <div class="style-button-icon">
        <b-icon icon="printer" ></b-icon>
      </div>
    </b-button>
</div>

</template>
<script>
import VueMonthlyPicker from 'vue-monthly-picker'
import { mapGetters } from 'vuex'
import moment from 'moment'
export default { 
  components: {VueMonthlyPicker},
  data: () => ({
    min_date: moment().set({'year': 2015, 'month': 11}),
    max_date: moment(),
    date_1: null,
    date_2: null,
    current_date: '',
    loader: false,
    item: {},
    data: [],  
    subsidy: 0,
    table_options: {perPage: 360},
    classes:{},
    responseFields:['period', 'balance_in', 'period_accrual_amount', 'period_amount_korr', 'period_amount_abon', 'period_pay_amount', 'period_pay_monet', 'balance_out'],
  }),
  computed: mapGetters(['userAccountBalanceInfoData', 'columns', 'locale', 'no_data_text', 'dates', 'pdf_error']),
  async mounted(){
    if(this.userAccountBalanceInfoData.err === "Сессия просрочена !"){
      await this.$store.dispatch('logout')
      this.$toastLocalized("sessionTerminated")
    }
    const MONTH_DATA = ['12', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11']
    const CURRENT_MONTH_DATA = [ '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11','12',]

    const MONTH = MONTH_DATA[new Date().getMonth()]
    const CURRENT_MONTH = CURRENT_MONTH_DATA[new Date().getMonth()]

    let year = new Date().getUTCFullYear() 
    let current_year = new Date().getUTCFullYear() 

    if(MONTH === '12'){ year = year - 1}

    this.date_1 = String(year) + '-' + String(MONTH) + '-01' 
    this.date_2 = String(current_year)+ '-' + String(CURRENT_MONTH) + '-01' 

   this.createFirstTable()
  },
  methods:{
    rowClass(/*item, type*/) {
      return 'text-center'
    },
    writtenDate(date){
      const year = date.substring(0, 4)
      const month = this.$store.state.dates[ parseInt(date.substring(5, 7)) -1 ]
      return `${month} ${year}`
    },
    async createFirstTable(){

       let dates = {
          date1: this.date_1,
          date2: this.date_2
        }      

      await this.$store.dispatch('userAccountBalanceInfo', dates )
      await this.$store.dispatch('userAccountBalanceInfoBills', dates )

      this.crerateTable()
    },
    async newTable(){
      let dates
      let dateFerst = '';
      let dateSec = '';

      if(this.date_1._i){

        if(this.date_1._i.replace(new RegExp('/','g'),'.').split('.')[1] < 10){

          let data = this.date_1._i.replace(new RegExp('/','g'),'.').split('.')[1] = '0' + this.date_1._i.replace(new RegExp('/','g'),'.').split('.')[1]
          dateFerst = this.date_1._i.replace(new RegExp('/','g'),'.').split('.')[0] + '.' + data + '.01'

        } else{ 

          dateFerst = this.date_1._i.replace(new RegExp('/','g'),'.').split('.').join(".") + '.01'

        }

      } else {

        dateFerst = this.date_1

      }
      if(this.date_2._i){

        if(this.date_2._i.replace(new RegExp('/','g'),'.').split('.')[1] < 10 ){

          let data = this.date_2._i.replace(new RegExp('/','g'),'.').split('.')[1] = '0' + this.date_2._i.replace(new RegExp('/','g'),'.').split('.')[1]
          dateSec = this.date_2._i.replace(new RegExp('/','g'),'.').split('.')[0] + '.' + data + '.01'

        } else{ 

          dateSec = this.date_2._i.replace(new RegExp('/','g'),'.').split('.').join(".") + '.01'

        }
      } else {

        dateSec = this.date_2

      }
      
      dates = {
        date1: dateFerst,
        date2: dateSec
      }      

      await this.$store.dispatch('userAccountBalanceInfo', dates )
      await this.$store.dispatch('userAccountBalanceInfoBills', dates )

    },
    async printPDF() {
      await this.$store.dispatch('userBillPrintPdf' )
      if(this.pdf_error){
        this.$messageLocalized("infoIsAbsent")
      }
    },
    async printInquiry() {
      await this.$store.dispatch('userInquiryPdf' )
      if(this.pdf_error){
        this.$messageLocalized("infoIsAbsent")
      }
    },
    async printTarifArchive() {
      await this.$store.dispatch('tarifArchivePdf' )
      if(this.pdf_error){
        this.$messageLocalized("infoIsAbsent")
      }
    },
    async printPDFArchive() {
      await this.$store.dispatch('userArchivePrintPdf', [this.date_1, this.date_2] )
      if(this.pdf_archive_error){
        this.$messageLocalized("printPreparationError")
      }
    }
  },
  watch: {
    columns(){
      if(this.userAccountBalanceInfoData.length){
        this.crerateTable()
        
      }
    },
  },
}
</script>
<style scoped>
.table thead th { display: table-cell; vertical-align: middle; }
@media (max-width: 767.98px) {
  .button-pay-all {
    height: auto;
    min-height: 64px;
    text-align: left;
  }
  .button-pay-all .style-button-icon{
    right: 4px;
    top: 4px;
  }
}
@media (max-width: 575.98px) {
  .button-pay-all {
    width: 300px !important;
  }
}

@media (min-width: 576px) and (max-width: 767.98px) {
  .button-pay-all {
    width: 400px !important;
  }
}
</style>